import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { pageLinks, socialLinks } from '../data';
import PageLinks from './PageLinks';
import SocialLink from './SocialLink';

const Navbar = ({ isAuthenticated, user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear(); // Clear session-based login
    onLogout();
    navigate('/login');
  };

  return (
    <nav className='navbar'>
      <div className='nav-center'>
        <div className='nav-header'>
          <h2>Smart Compliance</h2>
          <i className="fa-regular fa-file"></i>
        </div>

        <div className='nav-links'>
          <Link to="/">Home</Link>
          {isAuthenticated ? (
            <>
              <Link to="/dashboard">Dashboard</Link>
              <span style={{ marginLeft: '10px', fontWeight: 'bold', color: '#333' }}>
                Hello, {user?.firstName}
              </span>
              <button
                onClick={handleLogout}
                style={{
                  marginLeft: '10px',
                  border: 'none',
                  background: 'transparent',
                  color: 'red',
                  cursor: 'pointer'
                }}
              >
                Logout
              </button>
            </>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </div>

        <PageLinks parentClass='nav-links' itemClass='nav-link' />
        <ul className='nav-icons'>
          {socialLinks.map((link) => (
            <SocialLink {...link} key={link.id} itemClass='nav-icon' />
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

